var $b2b55661291de587$exports = {};
$b2b55661291de587$exports = {
  "removeButtonLabel": "Odebrat",
  "removeDescription": "Stisknut\xEDm kl\xE1vesy Delete odeberete zna\u010Dku."
};
export { $b2b55661291de587$exports as default };